//—— 對外的聯絡管道 ——
//
//  抽成一支共用的常數，不要在用到的地方各寫一份 ——
//  換帳號、換信箱時漏改一處，使用者就會寄到一個沒人看的地方。
//
//  ⚠️ policy-dialog.js 裡還有一份寫死的客服信箱。那一支是法律文件，
//  它自己的註解說明了「換網域、換客服信箱、公司更名必須全部一起改」——
//  要併過來的話得連同條款內文一起檢查，所以這裡先不動它。

//LINE 官方帳號。
//  手機上會喚起 LINE App，桌機開網頁版。
//
//  ⚠️ 後端的通知信裡還有一份（utils/report-mail.js 的 SUPPORT_LINE）。
//  跨 client/ 與根目錄沒辦法共用模組，只能抄一份 —— 換帳號時兩邊一起改，
//  漏掉一邊的症狀是「站上加得到好友，信裡那條連結卻是舊的」。
export const LINE_URL = "https://lin.ee/XuczvJR";

//客服信箱。就是寄出通知信的那個帳號（後端 .env 的 GMAIL_USER）——
//  使用者回信會回到同一個地方，不會落到沒人看的信箱。
export const SUPPORT_EMAIL = "yanyige95@gmail.com";

//服務時間。頁尾與後端通知信都會印，兩邊要一致
//  （後端那份在 utils/report-mail.js 的 SUPPORT_HOURS）。
export const SUPPORT_HOURS = "週一至週五 10:00–18:00";
